export default ({ next, store }) => {
  if (!store.getters.isDoerAndBigger) {
    return next({ name: 'profile' })
  }

  return next()
}
